import { csrfFetch } from '../../lib/helpers.js';
import Snack from '@effectivastudio/snackbar';
import IconButton from '../icon_button/element.js';
import translations from './translations.js';

/**
 * Interactive button
 * @prop active - Toggle state of the button. true results in active button; false - inactive
 * @prop count - The number of users that activated this button
 * @prop translation - translation string eg. 'likes.other', count prop will be passed as translation argument
 *
 *
 */
export default class InteractiveButton extends IconButton {
  /** @internal */
  static translations = translations;

  static properties = {
    active: { type: Boolean, reflect: true },
    count: { type: Number, reflect: true },
    translation: { type: String },
  };

  connectedCallback() {
    super.connectedCallback();
    this.text = this.translatedText;
  }

  createRenderRoot() {
    return this;
  }

  get translatedText() {
    return this.i18n.t(this.translation, { count: this.count });
  }

  onClick(e) {
    e.preventDefault();

    this.updateActiveState();
    this.fetch();
  }

  toggleActive() {
    this.active = !this.active;
  }

  updateActiveState() {
    this.toggleActive();
    this.updateCount();
    this.text = this.translatedText;
  }

  updateCount() {
    this.count += this.active ? +1 : -1;
    this.count = Math.max(this.count, 0);
  }

  fetch() {
    csrfFetch(this.href, {
      headers: {
        'Content-Type': 'application/json',
      },
      method: this.method,
      body: JSON.stringify({
        socket_id: window.App?.pusher?.connection?.socket_id,
      }),
    })
      .then(res => this.onFetchSuccess(res))
      .catch(res => this.onFetchError(res));
  }

  onFetchError() {
    this.displaySnackBarError();
    this.updateActiveState();
  }

  onFetchSuccess() {}

  displaySnackBarError() {
    Snack({
      text: this.t('snack.generic_error_msg'),
      customClass: 'snackbar-danger',
    });
  }
}

InteractiveButton.registerTagName('ef-interactive-button');

customElements.get('ef-interactive-button') ||
  customElements.define('ef-interactive-button', InteractiveButton);
